import { styled } from 'styled-components';

import { Link } from '@src/i18n/routing';

export const CardWrapper = styled.div`
  position: relative;
  display: grid;
  background: var(--color-white);
  grid-template-areas:
    'image content chevron'
    '. content chevron';
  grid-template-columns: 88px 1fr 24px;
  grid-template-rows: 88px auto;
  grid-column-gap: 16px;
  padding: 20px;
  border: var(--ds-size-stroke-thin) solid var(--ds-colors-outline-base-default);
  /* Bottom-only below 768px: the cards bleed edge to edge with no gap, so side
     outlines would hug the viewport and neighbours' would stack into a doubled line. */
  border-width: 0 0 var(--ds-size-stroke-thin);

  @media screen and (min-width: 768px) {
    border-radius: 16px;
    grid-template-columns: 140px 1fr 24px;
    border-width: var(--ds-size-stroke-thin);
  }
`;

export const CardImageWrapper = styled.div`
  grid-area: image;
  background-color: var(--color-white);
  position: relative;
  border-radius: 16px;

  img {
    display: block;
    height: 100%;
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
  }
`;

export const CardContent = styled.div`
  grid-area: content;
  flex-direction: column;
  justify-content: center;
  display: flex;

  @media screen and (min-width: 768px) {
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
`;

export const CardActions = styled.div`
  grid-area: actions;
  width: fit-content;
  column-gap: 16px;
  row-gap: 4px;
  display: flex;
  margin-top: 8px;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;

  a,
  button {
    width: unset;
    font: 500 16px / 20px var(--font-family-founders-grotesk);
    text-align: center;
  }
`;

export const ChevronWrapper = styled.div`
  grid-area: chevron;
  display: flex;
  align-items: center;
  color: var(--color-numa-black--400);
  justify-content: flex-end;
`;

export const PropertyName = styled.h4`
  font: 500 16px / 20px var(--font-family-founders-grotesk);
  color: var(--color-numa-black--400);
`;

/**
 * Wraps the property name and dates so the link has a meaningful accessible
 * name. The `::after` stretches over the whole card (its containing block is
 * `CardWrapper`, the nearest positioned ancestor) so the whole card is
 * clickable, not just this block.
 */
export const StretchedTitleLink = styled(Link)`
  &::after {
    content: '';
    position: absolute;
    inset: 0;
  }
`;
